export default __webpack_public_path__ + "static/media/v2_267.6730ed41.png";